var _objectSpread = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var Player_exports = {};
__export(Player_exports, {
  default: function _default() {
    return Player;
  }
});
module.exports = __toCommonJS(Player_exports);
var import_react = __toESM(require("react"));
var import_react_fast_compare = __toESM(require("react-fast-compare"));
var import_props = require("./props");
var import_utils = require("./utils");
var SEEK_ON_PLAY_EXPIRY = 5e3;
var Player = /*#__PURE__*/function (_import_react$Compone) {
  "use strict";

  _inherits(Player, _import_react$Compone);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Player).apply(this, arguments));
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "isReady", false);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "isPlaying", false);
    // Track playing state internally to prevent bugs
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "isLoading", true);
    // Use isLoading to prevent onPause when switching URL
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "loadOnReady", null);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "startOnPlay", true);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "seekOnPlay", null);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "onDurationCalled", false);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handlePlayerMount", function (player) {
      if (_this.player) {
        _this.progress();
        return;
      }
      _this.player = player;
      _this.player.load(_this.props.url);
      _this.progress();
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;
        var loadedSeconds = _this.getSecondsLoaded();
        var duration = _this.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
        onReady = _this$props.onReady,
        playing = _this$props.playing,
        volume = _this$props.volume,
        muted = _this$props.muted;
      onReady();
      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }
      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);
        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }
      _this.handleDurationCheck();
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
        onStart = _this$props2.onStart,
        onPlay = _this$props2.onPlay,
        playbackRate = _this$props2.playbackRate;
      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      _this.handleDurationCheck();
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handlePause", function (e) {
      _this.isPlaying = false;
      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleEnded", function () {
      var _this$props3 = _this.props,
        activePlayer = _this$props3.activePlayer,
        loop = _this$props3.loop,
        onEnded = _this$props3.onEnded;
      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }
      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleError", function () {
      var _this$props4;
      _this.isLoading = false;
      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);
      var duration = _this.getDuration();
      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);
          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleLoaded", function () {
      _this.isLoading = false;
    });
    return _this;
  }
  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);
      if (this.isReady && this.props.stopOnUnmount) {
        this.player.stop();
        if (this.player.disablePIP) {
          this.player.disablePIP();
        }
      }
      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (!this.player) {
        return;
      }
      var _this$props5 = this.props,
        url = _this$props5.url,
        playing = _this$props5.playing,
        volume = _this$props5.volume,
        muted = _this$props5.muted,
        playbackRate = _this$props5.playbackRate,
        pip = _this$props5.pip,
        loop = _this$props5.loop,
        activePlayer = _this$props5.activePlayer,
        disableDeferredLoading = _this$props5.disableDeferredLoading;
      if (!(0, import_react_fast_compare.default)(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, import_utils.isMediaStream)(url)) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }
        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }
      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }
      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }
      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }
      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }
      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }
      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();
          if (volume !== null) {
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }
      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }
      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type, keepPlaying) {
      var _this3 = this;
      if (!this.isReady) {
        if (amount !== 0) {
          this.seekOnPlay = amount;
          setTimeout(function () {
            _this3.seekOnPlay = null;
          }, SEEK_ON_PLAY_EXPIRY);
        }
        return;
      }
      var isFraction = !type ? amount > 0 && amount < 1 : type === "fraction";
      if (isFraction) {
        var duration = this.player.getDuration();
        if (!duration) {
          console.warn("ReactPlayer: could not seek using fraction \u2013\xA0duration not yet available");
          return;
        }
        this.player.seekTo(duration * amount, keepPlaying);
        return;
      }
      this.player.seekTo(amount, keepPlaying);
    }
  }, {
    key: "render",
    value: function render() {
      var Player2 = this.props.activePlayer;
      if (!Player2) {
        return null;
      }
      return /* @__PURE__ */import_react.default.createElement(Player2, _objectSpread({}, this.props, {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);
  return Player;
}(import_react.Component);
__publicField(Player, "displayName", "Player");
__publicField(Player, "propTypes", import_props.propTypes);
__publicField(Player, "defaultProps", import_props.defaultProps);